/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable @next/next/no-img-element */
// libraries
import dynamic from 'next/dynamic';
// utils
import { escolherPlaceholder } from '../../../../../../lib/placeholders';
import { isColorLight } from '../../../../../../utils/FunctionsGlobals';
import styles from './WelcomePiecesMenu.module.css';

// Chunk próprio (e SSR normal): as páginas de menu SEM calculadora não carregam
// nada a mais — o bloco só existe quando o builder gravou o placeholder.
const AvmCalculator = dynamic(() => import('../../../../../../components/avm/AvmCalculator'), {
    loading: () => null,
});
// Trabalhe Conosco em etapas (contrato §2): mesmo esquema, chunk próprio.
const TrabalheConosco = dynamic(() => import('../../../../../../components/tc/TrabalheConosco'), {
    loading: () => null,
});
// Anuncie seu imóvel com IA (CONTRATO.md §2/§7): mesmo esquema, chunk próprio — só carrega na
// página cujo HTML traz o marcador COM token (tenant no portão).
const AnuncieIa = dynamic(() => import('../../../../../../components/anuncie/AnuncieIa'), {
    loading: () => null,
});

// "Largura total" da Página do Site (cs2460 SD-0036, 22/10): a página encosta nas bordas, sem os
// 90% e o padding do container. Gate DUPLO (Daniel: só esta licença muda): o codsite tem que estar
// aqui E o builder tem que ter gravado `data-itp-full` (toggle do editor, que também só aparece
// para estes codsites). Fora disso as classes saem idênticas às de antes.
const LARGURA_TOTAL_CODSITES = [1722, 2460];

const WelcomePiecesMenu: React.FC<{ menu: any,site:any }> = ({ menu,site }) => {
    // useState
    const cor_texto = isColorLight(site?.cor5) ? site?.cor11 : site?.cor13; 
    const larguraTotal = LARGURA_TOTAL_CODSITES.includes(Number(site?.id))
        && String(menu?.Conteudo ?? '').includes('data-itp-full');
    const clsOneStep = larguraTotal ? `${styles.oneStep} ${styles.oneStepFull}` : styles.oneStep;
    const clsTerms = larguraTotal ? `${styles.adjust_terms} ${styles.adjust_termsFull}` : styles.adjust_terms;
    // Calculadora de avaliação (CONTRATO-AVM-SITE.md §1), Trabalhe Conosco e Anuncie com IA: o
    // HTML da página pode trazer o placeholder do builder. Sem placeholder — ou com JSON
    // inválido/tenant sem token — `escolhido` é null e a página segue exatamente como hoje (o
    // fallback do bloco aparece no próprio HTML). Com mais de um, vale o que aparece PRIMEIRO; os
    // outros ficam como HTML cru (lib/placeholders.ts — a mesma regra de antes entre AVM e TC).
    // Os três ramos usam EXATAMENTE os mesmos wrappers/classes/estilos.
    const escolhido = escolherPlaceholder(menu?.Conteudo);

    if (escolhido && escolhido.tipo === 'tc') {
        const splitTc = escolhido.split;
        return (
            <div className={clsOneStep} style={{color: cor_texto,background: site?.cor5}}>
                <div className={clsTerms} style={{color: cor_texto}} dangerouslySetInnerHTML={{ __html: splitTc.antes}}>
                </div>
                <TrabalheConosco config={splitTc.config} fallbackHtml={splitTc.fallback} />
                <div className={clsTerms} style={{color: cor_texto}} dangerouslySetInnerHTML={{ __html: splitTc.depois}}>
                </div>
            </div>
        );
    }

    if (escolhido && escolhido.tipo === 'avm') {
        const split = escolhido.split;
        return (
            <div className={clsOneStep} style={{color: cor_texto,background: site?.cor5}}>
                <div className={clsTerms} style={{color: cor_texto}} dangerouslySetInnerHTML={{ __html: split.antes}}>
                </div>
                <AvmCalculator config={split.config} site={site} />
                <div className={clsTerms} style={{color: cor_texto}} dangerouslySetInnerHTML={{ __html: split.depois}}>
                </div>
            </div>
        );
    }

    if (escolhido && escolhido.tipo === 'anuncie') {
        const splitAn = escolhido.split;
        return (
            <div className={clsOneStep} style={{color: cor_texto,background: site?.cor5}}>
                <div className={clsTerms} style={{color: cor_texto}} dangerouslySetInnerHTML={{ __html: splitAn.antes}}>
                </div>
                <AnuncieIa config={splitAn.config} fallbackHtml={splitAn.fallback} site={site} />
                <div className={clsTerms} style={{color: cor_texto}} dangerouslySetInnerHTML={{ __html: splitAn.depois}}>
                </div>
            </div>
        );
    }

    return (
        <div className={clsOneStep} style={{color: cor_texto,background: site?.cor5}}>
            <div className={clsTerms} style={{color: cor_texto}} dangerouslySetInnerHTML={{ __html: menu?.Conteudo}}>
            </div>
        </div>
    );
};

export default WelcomePiecesMenu;

export const getServerSideProps = async () => ({ notFound: true });
